import { CalendarData } from "../../interfaces/EspolAds/CalendarData";
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Box, Button, CardContent, Typography,Grid, Chip, IconButton } from '@mui/material';
import {GrLink} from 'react-icons/gr';
import CardMedia from '@mui/material/CardMedia';
import { format } from "date-fns";

interface MiModalProps {
  isOpen: boolean;
  toggle: () => void;
  anuncio: CalendarData;
}

export const ModalAnuncio: React.FC<MiModalProps> = ({ isOpen, toggle, anuncio }) => {
  
  function abrirEnlace(enlace:string){
    window.open(enlace, '_blank');
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="custom-modal">
      <ModalHeader toggle={toggle}>        
        <Typography variant="h5" component="div" gutterBottom>
        {anuncio.txTitulo}
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={6} lg={6}>
        <CardMedia
            component="img"
            sx={{ width: '100%',height: '100%'}}
            image={anuncio.txImagen}
            alt={anuncio.txTitulo}
        />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent >
          <Typography component="div" variant="h5">
            {anuncio.txTexto}
          </Typography>
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
        {anuncio.dtInicio.length > 0 ?
            <Chip label={"Fecha Inicio: "+ format(new Date(anuncio.dtInicio), 'dd/MM/yyyy HH:mm:ss')} variant="outlined" />
            : <></>
        }
        {anuncio.dtFin.length > 0 ?
            <Chip label={"Fecha Fin: "+ format(new Date(anuncio.dtFin), 'dd/MM/yyyy HH:mm:ss')} variant="outlined" />
            : <></>
        }
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
        { anuncio.txUrl !==null && anuncio.txUrl.length > 0 ?
            <IconButton color="primary" onClick={() => abrirEnlace(anuncio.txUrl)}>
              <GrLink />
            </IconButton>
            // <Button variant="contained" onClick={() => abrirEnlace(anuncio.txUrl)}><GrLink /></Button>            
            : <></>
        }
        </Box>
        </Box>
        </Grid>        
        </Grid>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} >
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};